import type { QuizHardestQuestionDto } from '@peach/types/quizzes/quiz-attempt.dto.js';
import { resultLine } from '@/lib/quiz/result-line';
import { QuizReview } from './QuizReview';

/**
 * What a finished play says, wherever it finishes: the score naming the call,
 * then the questions worth going over. The storefront's card and the prebuilt
 * page both draw it, so a follower and a creator rehearsing read one thing.
 */
export function QuizResult({
  score,
  total,
  name,
  missed,
  hardest,
}: {
  score: number;
  total: number;
  /** The provider's first name. */
  name: string;
  missed: readonly string[];
  hardest?: readonly QuizHardestQuestionDto[];
}) {
  return (
    <>
      <span className="sf-title sf-num whitespace-pre-line text-title-2 font-extrabold leading-tight">
        {resultLine({ score, total, name })}
      </span>
      <div className="mt-auto">
        <QuizReview missed={missed} hardest={hardest} />
      </div>
    </>
  );
}
